module.exports = __webpack_public_path__ + "static/media/29BDOS12.d2281b31.jpg";